"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_MODULE = exports.SelectModule = exports.InputModule = exports.LabeledModule = exports.SurveyModule = void 0;
const util_1 = require("./util");
class SurveyModule {
    constructor({ actionRequired = false, id = (0, util_1.generateUUID)(), languageCode = "en", noBorder = false, style = {}, tag, }) {
        this.actionRequired = actionRequired;
        this._id = id;
        this.noBorder = noBorder;
        this.style = style;
        this._languageCode = languageCode;
        if (tag) {
            this.tag = tag;
        }
    }
    get id() {
        return this._id;
    }
    get type() {
        return this._type;
    }
    get languageCode() {
        return this._languageCode;
    }
    set languageCode(langCode) {
        this._languageCode = langCode;
    }
}
exports.SurveyModule = SurveyModule;
class LabeledModule extends SurveyModule {
    constructor(_a) {
        var { label = { en: "" } } = _a, rest = __rest(_a, ["label"]);
        super(rest);
        this.label = label;
    }
}
exports.LabeledModule = LabeledModule;
class InputModule extends LabeledModule {
    constructor(_a) {
        var { required = true } = _a, rest = __rest(_a, ["required"]);
        super(rest);
        this.required = required;
    }
}
exports.InputModule = InputModule;
class SelectModule extends InputModule {
    constructor(_a) {
        var { options = [], randomizeOptions = false } = _a, rest = __rest(_a, ["options", "randomizeOptions"]);
        super(rest);
        this.options = options;
        this.randomizeOptions = randomizeOptions;
    }
}
exports.SelectModule = SelectModule;
const INVALID_MODULE = (mod) => `unable to validate ${mod.type} module`;
exports.INVALID_MODULE = INVALID_MODULE;
//# sourceMappingURL=base.js.map